import React from 'react';
import classnames from 'classnames';
import { useParams } from 'umi';
import { IStudioInfo } from '@/pages/home/pages/studio/type';
import CasualOverview from './CasualOverview';
import CasualCompetitors from './CasualCompetitors';
import './index.scss';

import type { ICasualCompetitorsDefaultGenre } from './CasualCompetitors/types';

type TCasualHubHostMode = 'home' | 'intelligence';
type TCasualHubTabKey = 'overview' | 'competitors';

interface ICasualHubProps {
  studioInfo: IStudioInfo;
  hostMode?: TCasualHubHostMode;
  enabledTabs?: TCasualHubTabKey[];
  hideTabSwitcher?: boolean;
  defaultCompetitorsGenre?: ICasualCompetitorsDefaultGenre;
}

interface ICasualHubParams {
  studioId?: string;
  tab?: string;
}

const DEFAULT_ENABLED_TABS: TCasualHubTabKey[] = ['overview', 'competitors'];

const PATH_TO_TAB_KEY: Record<string, string> = {
  '/home': 'overview',
  '/competitors': 'competitors',
};

/**
 * Casual Hub 内容区：Overview / 竞品切换；顶栏由 CasualHubChrome 负责。
 */
const CasualHub: React.FC<ICasualHubProps> = (props) => {
  const {
    studioInfo,
    enabledTabs = DEFAULT_ENABLED_TABS,
    defaultCompetitorsGenre,
  } = props;
  const { tab } = useParams() as ICasualHubParams;

  const dashboardList = (studioInfo?.data as any)?.studio_dashboard_list || [];
  const tabs = dashboardList
    .map((item: { path?: string; }) => {
      const key = PATH_TO_TAB_KEY[item.path || ''] || item.path?.replace(/^\//, '');
      return key;
    })
    .filter((key: string) => enabledTabs.includes(key as TCasualHubTabKey));
  const defaultKey = tabs[0] || enabledTabs[0] || 'overview';
  const knownTabKeys = new Set(tabs);
  const activeKey = (tab && knownTabKeys.has(tab)) ? tab : defaultKey;

  const renderContent = (): React.ReactNode => {
    if (activeKey === 'competitors') {
      return <CasualCompetitors studioInfo={studioInfo} defaultCompetitorsGenre={defaultCompetitorsGenre} />;
    }
    return <CasualOverview studioInfo={studioInfo} />;
  };

  return (
    <div className="dbh-casual-hub">
      <div className={classnames('dbh-casual-hub__content', { 'no-padding-bottom': activeKey === 'competitors' })}>
        {renderContent()}
      </div>
    </div>
  );
};

export default CasualHub;
